/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{flex:auto;display:flex;flex-direction:column}.filter-panel[_ngcontent-%COMP%]{display:flex;justify-items:start;padding:10px;background-color:#f5f5f5}dx-data-grid[_ngcontent-%COMP%]{flex:auto;height:calc(100% - 150px)}.link[_ngcontent-%COMP%]{color:#00f}"];
export { styles as styles };
